import Breakpoints from "helpers/breakpoints";

let b = new Breakpoints();

let SwiperCarouselPortraitBreakpoints = {};

SwiperCarouselPortraitBreakpoints[b.getMax('mobilePortrait') ] = {

    slidesPerView: 3,
    slidesPerGroup: 3,

}

SwiperCarouselPortraitBreakpoints[b.getMax('mobileLandscape') ] = {

    slidesPerView: 4,
    slidesPerGroup: 4,

}

SwiperCarouselPortraitBreakpoints[b.getMax('tabletPortrait') ] = {

    slidesPerView: 5,
    slidesPerGroup: 5,

}

SwiperCarouselPortraitBreakpoints[b.getMax('tabletLandscape') ] = {

    slidesPerView: 6,
    slidesPerGroup: 6,

}

SwiperCarouselPortraitBreakpoints[b.getMax('desktop') ] = {

    slidesPerView: 8,
    slidesPerGroup: 8

}

SwiperCarouselPortraitBreakpoints[b.getMax('desktopWide') ] = {

    slidesPerView: 8,
    slidesPerGroup: 8
}

export {SwiperCarouselPortraitBreakpoints};
let SwiperCarouselLandsCapeBreakpoints = {};

SwiperCarouselLandsCapeBreakpoints[b.getMax('mobilePortrait') ] = {

    slidesPerView: 2,
    slidesPerGroup: 2,

}

SwiperCarouselLandsCapeBreakpoints[b.getMax('mobileLandscape') ] = {

    slidesPerView: 2,
    slidesPerGroup: 2,

}

SwiperCarouselLandsCapeBreakpoints[b.getMax('tabletPortrait') ] = {

    slidesPerView: 3,
    slidesPerGroup: 3,

}

SwiperCarouselLandsCapeBreakpoints[b.getMax('tabletLandscape') ] = {

    slidesPerView: 4,
    slidesPerGroup: 4

}

SwiperCarouselLandsCapeBreakpoints[b.getMax('desktop') ] = {

    slidesPerView: 5,
    slidesPerGroup: 5
}

SwiperCarouselLandsCapeBreakpoints[b.getMax('desktopWide') ] = {

    slidesPerView: 6,
    slidesPerGroup: 6

}

export {SwiperCarouselLandsCapeBreakpoints}

let SwiperCarouselBrandsLandsCapeBreakpoints = {};

SwiperCarouselBrandsLandsCapeBreakpoints[b.getMax('mobilePortrait') ] = {

    slidesPerView: 3,
    slidesPerGroup: 3,

}

SwiperCarouselBrandsLandsCapeBreakpoints[b.getMax('mobileLandscape') ] = {

    slidesPerView: 3,
    slidesPerGroup: 3,

}

SwiperCarouselBrandsLandsCapeBreakpoints[b.getMax('tabletPortrait') ] = {

    slidesPerView: 6,
    slidesPerGroup: 6,

}

SwiperCarouselBrandsLandsCapeBreakpoints[b.getMax('tabletLandscape') ] = {

    slidesPerView: 6,
    slidesPerGroup: 6,

}

SwiperCarouselBrandsLandsCapeBreakpoints[b.getMax('desktop') ] = {

    slidesPerView: 6,
    slidesPerGroup: 6,

}

SwiperCarouselBrandsLandsCapeBreakpoints[b.getMax('desktopWide') ] = {

    slidesPerView: 6,
    slidesPerGroup: 6,

}

export {SwiperCarouselBrandsLandsCapeBreakpoints}


let OnNowCarouselLandsCapeBreakpoints = {};

OnNowCarouselLandsCapeBreakpoints[b.getMax('mobilePortrait')] = {

    slidesPerView: 2,
    slidesPerGroup: 2,

}

OnNowCarouselLandsCapeBreakpoints[b.getMax('mobileLandscape') ] = {

    slidesPerView: 2,
    slidesPerGroup: 2,

}

OnNowCarouselLandsCapeBreakpoints[b.getMax('tabletPortrait')] = {

    slidesPerView: 2,
    slidesPerGroup: 2,

}

OnNowCarouselLandsCapeBreakpoints[b.getMax('tabletLandscape')] = {

    slidesPerView: 3,
    slidesPerGroup: 3,

}

OnNowCarouselLandsCapeBreakpoints[b.getMax('desktop')] = {

    slidesPerView: 3,
    slidesPerGroup: 3,

}

OnNowCarouselLandsCapeBreakpoints[b.getMax('desktopWide')] = {

    slidesPerView: 4,
    slidesPerGroup: 4,

}

export {OnNowCarouselLandsCapeBreakpoints}

let OnNowCarouselPortraitBreakpoints = {};

OnNowCarouselPortraitBreakpoints[b.getMax('mobilePortrait') ] = {

    slidesPerView: 2,
    slidesPerGroup: 2,

}

OnNowCarouselPortraitBreakpoints[b.getMax('mobileLandscape') ] = {

    slidesPerView: 2,
    slidesPerGroup: 2,

}

OnNowCarouselPortraitBreakpoints[b.getMax('tabletPortrait') ] = {

    slidesPerView: 3,
    slidesPerGroup: 3,

}

OnNowCarouselPortraitBreakpoints[b.getMax('tabletLandscape') ] = {

    slidesPerView: 4,
    slidesPerGroup: 4

}

OnNowCarouselPortraitBreakpoints[b.getMax('desktop') ] = {

    slidesPerView: 5,
    slidesPerGroup: 5
}

OnNowCarouselPortraitBreakpoints[b.getMax('desktopWide') ] = {

    slidesPerView: 6,
    slidesPerGroup: 6

}

export {OnNowCarouselPortraitBreakpoints}

let BrandCarouselLandsCapeBreakpoints = {};

BrandCarouselLandsCapeBreakpoints[b.getMax('mobilePortrait')] = {

    slidesPerView: 3,
    slidesPerGroup: 3,

}

BrandCarouselLandsCapeBreakpoints[b.getMax('mobileLandscape') ] = {

    slidesPerView: 3,
    slidesPerGroup: 3,

}

BrandCarouselLandsCapeBreakpoints[b.getMax('tabletPortrait')] = {

    slidesPerView: 6,
    slidesPerGroup: 6,

}

BrandCarouselLandsCapeBreakpoints[b.getMax('tabletLandscape')] = {

    slidesPerView: 6,
    slidesPerGroup: 6,

}

BrandCarouselLandsCapeBreakpoints[b.getMax('desktop')] = {

    slidesPerView: 6,
    slidesPerGroup: 6,

}

BrandCarouselLandsCapeBreakpoints[b.getMax('desktopWide')] = {

    slidesPerView: 6,
    slidesPerGroup: 6,

}

export {BrandCarouselLandsCapeBreakpoints}

let SwiperLiveTVBreakpoints = {};
SwiperLiveTVBreakpoints[b.getMax('mobilePortrait')] = {

    slidesPerView: 2,
    slidesPerGroup: 2,

}

SwiperLiveTVBreakpoints[b.getMax('mobileLandscape')] = {

    slidesPerView: 3,
    slidesPerGroup: 3,

}

SwiperLiveTVBreakpoints[b.getMax('tabletPortrait')] = {

    slidesPerView: 4,
    slidesPerGroup: 4,

}

SwiperLiveTVBreakpoints[b.getMax('tabletLandscape')] = {

    slidesPerView: 5,
    slidesPerGroup: 5,

}

SwiperLiveTVBreakpoints[b.getMax('desktop')] = {

    slidesPerView: 6,
    slidesPerGroup: 6,

}

SwiperLiveTVBreakpoints[b.getMax('desktopWide')] = {

    slidesPerView: 6,
    slidesPerGroup: 6,

}

SwiperLiveTVBreakpoints[9999] = {

    slidesPerView: 6,
    slidesPerGroup: 6,

}

export {SwiperLiveTVBreakpoints}

//
// AA Upsell Portrait Carousel
//

let SwiperUpsellPortrait = {
    [b.getMax('mobilePortrait')]: {
        slidesPerView: 3,
        slidesPerGroup: 3,
    },

    [b.getMax('mobileLandscape')]: {
        slidesPerView: 3,
        slidesPerGroup: 3,
    },

    [b.getMax('tabletPortrait')]: {
        slidesPerView: 4,
        slidesPerGroup: 4,
    },

    [b.getMax('tabletLandscape')]: {
        slidesPerView: 7,
        slidesPerGroup: 7,
    },

    [b.getMax('desktop')]: {
        slidesPerView: 7,
        slidesPerGroup: 7,
    },

    [9999]: {
        slidesPerView: 7,
        slidesPerGroup: 7,
    }
};

export { SwiperUpsellPortrait }


//
// AA Upsell Landscape Carousel
//

let SwiperUpsellLandscape = {
    [b.getMax('mobilePortrait')]: {
        slidesPerView: 2,
        slidesPerGroup: 2,
    },

    [b.getMax('mobileLandscape')]: {
        slidesPerView: 2,
        slidesPerGroup: 2,
    },

    [b.getMax('tabletPortrait')]: {
        slidesPerView: 2,
        slidesPerGroup: 2,
    },

    [b.getMax('tabletLandscape')]: {
        slidesPerView: 4,
        slidesPerGroup: 4,
    },

    [b.getMax('desktop')]: {
        slidesPerView: 4,
        slidesPerGroup: 4,
    },

    [9999]: {
        slidesPerView: 4,
        slidesPerGroup: 4,
    }
};

export { SwiperUpsellLandscape }

// Avatar Carousel
// spaceBetween reflects the margin-right (in px) applied to items
let SquareCarouselDefaultBreakpointRules = {
    [b.getMax('mobilePortrait') ]: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 32,
    },
    [b.getMax('mobileLandscape') ]: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 32,
    },
    [b.getMax('tabletPortrait') ]: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 64,
    },
    [b.getMax('tabletLandscape') ]: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 56,
    },
    [b.getMax('desktop') ]: {
        slidesPerView: 6,
        slidesPerGroup: 6,
        spaceBetween: 54,
    },
    [b.getMax('desktopWide') ]: {
        slidesPerView: 6,
        slidesPerGroup: 6,
        spaceBetween: 88,
    },
}
export {SquareCarouselDefaultBreakpointRules}

let KidsLandsCapeBreakpoints = {};

KidsLandsCapeBreakpoints[b.getMax('mobilePortrait')] = {

    slidesPerView: 2,
    slidesPerGroup: 2,

}

KidsLandsCapeBreakpoints[b.getMax('mobileLandscape') ] = {

    slidesPerView: 2,
    slidesPerGroup: 2,

}

KidsLandsCapeBreakpoints[b.getMax('tabletPortrait')] = {

    slidesPerView: 3,
    slidesPerGroup: 3,

}

KidsLandsCapeBreakpoints[b.getMax('tabletLandscape')] = {

    slidesPerView: 4,
    slidesPerGroup: 4,

}

KidsLandsCapeBreakpoints[b.getMax('desktop')] = {

    slidesPerView: 5,
    slidesPerGroup: 5,

}

KidsLandsCapeBreakpoints[b.getMax('desktopWide')] = {

    slidesPerView: 6,
    slidesPerGroup: 6,

}

export {KidsLandsCapeBreakpoints}
